import React from "react";

interface HpPrintOsSupportIconProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

/**
 * External-link icon for "Open PrintOS Support".
 * 24×24 frame with ~12.5% inset glyph (matches Figma).
 */
export const HpPrintOsSupportIcon: React.FC<HpPrintOsSupportIconProps> = ({
  width = 24,
  height = 24,
  fill = "#787878",
  className,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      {/* Glyph inset ~12.5% so it centers in the 24×24 frame */}
      <g transform="translate(3 3)">
        <path
          d="M11.38 0.016C11.2 0.063 11.05 0.216 11.01 0.389C11 0.463 11.01 0.602 11.03 0.668C11.09 0.825 11.23 0.952 11.39 0.986C11.44 0.998 11.81 1 13.87 1C15.2 1 16.28 1.002 16.28 1.006C16.28 1.01 14.78 2.522 12.93 4.365C9.81 7.492 9.58 7.72 9.55 7.775C9.52 7.839 9.5 7.938 9.5 8.002C9.5 8.182 9.61 8.363 9.78 8.445C9.92 8.515 10.08 8.515 10.22 8.445C10.28 8.419 10.51 8.19 13.63 5.067C15.48 3.224 16.99 1.716 16.99 1.716C17 1.716 17 2.803 17 4.131C17 6.191 17 6.555 17.01 6.608C17.05 6.768 17.17 6.912 17.33 6.97C17.4 6.993 17.54 7.001 17.61 6.986C17.74 6.959 17.88 6.851 17.94 6.732C18 6.608 18 6.882 18 3.498C18 0.1 18 0.388 17.94 0.264C17.88 0.158 17.79 0.077 17.67 0.028L17.61 0.006L14.52 0.005C11.84 0.003 11.42 0.005 11.38 0.016ZM1.73 3.018C1.22 3.089 0.76 3.353 0.44 3.754C0.23 4.014 0.1 4.309 0.03 4.664L0.01 4.768L0 10.433C0 14.483 0 16.125 0.01 16.197C0.06 16.658 0.26 17.082 0.59 17.412C0.75 17.574 0.94 17.705 1.15 17.806C1.35 17.903 1.57 17.966 1.8 17.988C1.87 17.995 3.52 17.997 7.57 17.995L13.23 17.992L13.34 17.972C13.55 17.929 13.71 17.877 13.89 17.787C14.5 17.487 14.91 16.892 14.99 16.224C14.99 16.159 15 15.191 14.99 12.759L14.99 9.385L14.97 9.331C14.89 9.107 14.66 8.971 14.43 9.007C14.24 9.036 14.08 9.169 14.02 9.362C14 9.41 14 9.537 14 12.791C13.99 15.454 13.99 16.179 13.98 16.21C13.94 16.364 13.88 16.5 13.8 16.601C13.74 16.676 13.64 16.776 13.56 16.827C13.48 16.883 13.35 16.94 13.25 16.97L13.16 16.995L7.54 16.998C2.39 17 1.92 16.999 1.84 16.985C1.63 16.951 1.45 16.857 1.29 16.706C1.14 16.554 1.05 16.371 1.01 16.16C1 16.077 1 15.608 1 10.455L1 4.841L1.03 4.75C1.13 4.377 1.39 4.128 1.79 4.018C1.82 4.009 2.55 4.006 5.21 4.002C8.46 3.997 8.59 3.996 8.64 3.981C8.83 3.916 8.97 3.761 8.99 3.569C9.03 3.338 8.89 3.113 8.67 3.029L8.61 3.009L5.22 3.008C2.45 3.006 1.8 3.008 1.73 3.018Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
